//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "DateComp",
  components: {},
  props: ["loading"],
  data: function data() {
    var _this = this;

    return {
      btnType: "30day",
      startDate: Date.now() - 3600000 * 24 * 30,
      endDate: Date.now(),
      minDate: null,
      pickOptionForStart: {
        disabledDate: function disabledDate(time) {
          if (_this.endDate) {
            return (time.getTime() > _this.endDate ? true : false) || time.getTime() > Date.now();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      pickOptionForEnd: {
        disabledDate: function disabledDate(time) {
          if (_this.startDate) {
            return (time.getTime() < _this.startDate ? true : false) || time.getTime() > Date.now();
          } else {
            return time.getTime() > Date.now();
          }
        }
      }
    };
  },
  created: function created() {},
  computed: {},
  mounted: function mounted() {},
  methods: {
    setDate: function setDate(btnType) {
      var _this2 = this;

      this.btnType = btnType;

      switch (btnType) {
        case "yesterday":
          this.startDate = Date.now() - 3600000 * 24;
          this.endDate = Date.now() - 3600000 * 24;
          break;

        case "today":
          this.startDate = Date.now();
          this.endDate = Date.now();
          break;

        case "7day":
          this.startDate = Date.now() - 3600000 * 24 * 7;
          this.endDate = Date.now();
          break;

        case "30day":
          this.startDate = Date.now() - 3600000 * 24 * 30;
          this.endDate = Date.now();
          break;

        default:
          break;
      }

      this.$nextTick(function () {
        _this2.$emit("change", [_this2.startDate, _this2.endDate]);

        _this2.$emit("changehandle", [_this2.timestampToTime(_this2.startDate), _this2.timestampToTime(_this2.endDate)]);
      });
    },
    changeValue: function changeValue(value) {
      this.btnType = "other"; // if (value && value.length) {
      //   this.$emit("change", [
      //     this.$options.filters.filterDate(this.startDate, "yyyy-MM-dd"),
      //     this.$options.filters.filterDate(this.endDate, "yyyy-MM-dd")
      //   ]);
      // }
    },
    getValue: function getValue() {
      var startDate = this.startDate || Date.now() - 86400000 * 30;
      var endDate = this.endDate || Date.now();
      endDate = this.btnType == "other" ? endDate + 86399000 : endDate;
      return [startDate, endDate];
    },
    getValueStr: function getValueStr() {
      var startDate = this.startDate || Date.now() - 86400000 * 30;
      var endDate = this.endDate || Date.now();
      endDate = this.btnType == "other" ? endDate + 86399000 : endDate;
      return [this.timestampToTime(startDate), this.timestampToTime(this.timestampToTime(endDate))];
    },
    timestampToTime: function timestampToTime(timestamp) {
      var date = new Date(timestamp);
      var Y = date.getFullYear() + "-";
      var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
      var D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
      return Y + M + D;
    }
  }
};